import React from 'react';
import { Link } from 'react-router-dom';

// elebyte.io's footer, in document flow: the E, a line of links, then the fine print with the legal
// pages. Legal and company links go to elebyte.io, which serves /terms, /privacy and /cookies.
const SUPPORT_LINKS = [
  { label: 'Knowledge Base', path: '/kb' },
  { label: 'Submit Ticket', path: '/tickets/new' },
  { label: 'My Tickets', path: '/tickets' },
];

const LEGAL_LINKS = [
  { label: 'Terms of Service', href: 'https://elebyte.io/terms' },
  { label: 'Privacy Policy', href: 'https://elebyte.io/privacy' },
  { label: 'Cookie Policy', href: 'https://elebyte.io/cookies' },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="sp-footer" aria-label="Site footer">
      <div className="sp-footer__inner">
        <div className="sp-footer__top">
          <img className="sp-footer__mark" src="/glyph-e-cap.svg" alt="" aria-hidden="true" />
          <nav className="sp-footer__links" aria-label="Support">
            {SUPPORT_LINKS.map((link) => (
              <Link key={link.path} to={link.path}>{link.label}</Link>
            ))}
            <a href="https://elebyte.io">elebyte.io</a>
            <a href="https://status.elebyte.io" target="_blank" rel="noopener noreferrer">System Status</a>
          </nav>
        </div>
        <div className="sp-footer__fine">
          <p>
            © {currentYear} Elebyte GTM OS, the AI-native GTM operating system. ·{' '}
            <a href="mailto:contact@elebyte.io">Contact</a>
          </p>
          <nav aria-label="Legal">
            {LEGAL_LINKS.map((link) => (
              <a key={link.href} href={link.href}>{link.label}</a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
